/* =============================================================
   Marbella Home Hero Carousel
   - Slow auto-advance (8s default)
   - Pause on hover / focus / touch / off-screen
   - Fade transitions
   - Mobile swipe
   - Keyboard arrows (when focused)
   - Lazy-load slides 2+
   - Respects prefers-reduced-motion
   ============================================================= */
(function () {
  if (window.__marbellaHHInit) return;
  window.__marbellaHHInit = true;

  function initHero(root) {
    if (root.dataset.hhInit) return;
    root.dataset.hhInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hh-slide]'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hh-dot]'));
    var prevBtn = root.querySelector('[data-hh-prev]');
    var nextBtn = root.querySelector('[data-hh-next]');
    var viewport = root.querySelector('[data-hh-viewport]');
    var progressBar = root.querySelector('[data-hh-progress-bar]');

    var current = 0;
    var autoplay = root.dataset.hhAutoplay === '1' && slides.length > 1;
    var intervalMs = parseInt(root.dataset.hhInterval || '8000', 10);
    var timer = null;
    var paused = false;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) autoplay = false;

    if (progressBar) {
      progressBar.style.setProperty('--hh-progress-duration', (intervalMs / 1000) + 's');
    }

    function setSlide(next) {
      if (next === current) return;
      next = (next + slides.length) % slides.length;

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');

      slides[next].classList.add('is-active');
      slides[next].removeAttribute('aria-hidden');

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === next);
      });

      current = next;
      restartProgress();
    }

    function step(dir) {
      setSlide(current + dir);
    }

    function startTimer() {
      if (!autoplay || paused) return;
      stopTimer();
      timer = setTimeout(function () { step(1); }, intervalMs);
    }
    function stopTimer() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function restartProgress() {
      if (!progressBar) return;
      // restart the CSS transition
      progressBar.classList.remove('is-running');
      progressBar.classList.add('is-paused');
      // reflow
      void progressBar.offsetWidth;
      progressBar.classList.remove('is-paused');
      if (autoplay && !paused) {
        progressBar.classList.add('is-running');
      }
      stopTimer();
      startTimer();
    }

    function pause() {
      paused = true;
      stopTimer();
      if (progressBar) {
        // freeze progress visually
        var computed = window.getComputedStyle(progressBar).width;
        progressBar.style.width = computed;
        progressBar.classList.remove('is-running');
      }
    }
    function resume() {
      if (!paused) return;
      paused = false;
      if (progressBar) {
        progressBar.style.width = '';
      }
      restartProgress();
    }

    /* --- Click handlers --- */
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { setSlide(i); });
    });

    /* --- Pause on hover / focus --- */
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);

    /* --- Keyboard navigation --- */
    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    /* --- Touch swipe --- */
    if (viewport) {
      var startX = 0, startY = 0, tracking = false;
      var SWIPE_THRESHOLD = 50;

      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        pause();
      }, { passive: true });

      viewport.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          step(dx < 0 ? 1 : -1);
        }
        // resume after a short delay so user can see the swiped slide
        setTimeout(resume, 3000);
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () {
        tracking = false;
        setTimeout(resume, 1000);
      }, { passive: true });
    }

    /* --- Pause when off-screen (saves CPU + battery) --- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            resume();
          } else {
            pause();
          }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    }

    /* --- Pause when tab not visible --- */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else resume();
    });

    /* --- Initial start --- */
    if (autoplay && progressBar) {
      // delay so the first slide's content animation can run first
      setTimeout(function () {
        progressBar.classList.add('is-running');
      }, 400);
    }
    startTimer();
  }

  function boot() {
    document.querySelectorAll('[data-hh]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
